/**
 * App configuration (replaces expo-constants / app.json extra).
 * Set values via `.env` using EXPO_PUBLIC_* or REACT_APP_* keys.
 *
 * IMPORTANT: read env with static `process.env.NAME` access so Metro/Babel
 * and Vite can inline values at build time. Dynamic `process.env[key]` is not replaced.
 */

function readEnv(...values) {
  for (const value of values) {
    const normalized = value != null ? String(value).trim() : "";
    if (normalized) return normalized;
  }
  return "";
}

function readBoolEnv(...values) {
  const raw = readEnv(...values).toLowerCase();
  return raw === "true" || raw === "1" || raw === "yes";
}

export const appConfig = {
  nextDnsConfigUrl:
    readEnv(
      process.env.EXPO_PUBLIC_NEXT_DNS_CONFIG_URL,
      process.env.REACT_APP_NEXT_DNS_CONFIG_URL,
    ) || "https://my.nextdns.io",
  iosFamilyControlsBlockingUiEnabled: readBoolEnv(
    process.env.EXPO_PUBLIC_IOS_FAMILY_CONTROLS_BLOCKING_UI_ENABLED,
    process.env.REACT_APP_IOS_FAMILY_CONTROLS_BLOCKING_UI_ENABLED,
  ),
  blocklistApiUrl: readEnv(
    process.env.EXPO_PUBLIC_BLOCKLIST_API_URL,
    process.env.REACT_APP_BLOCKLIST_API_URL,
  ),
  anthropicApiKey: readEnv(
    process.env.EXPO_PUBLIC_ANTHROPIC_API_KEY,
    process.env.REACT_APP_ANTHROPIC_API_KEY,
  ),
  communityApiUrl: readEnv(
    process.env.EXPO_PUBLIC_COMMUNITY_API_URL,
    process.env.REACT_APP_COMMUNITY_API_URL,
  ),
};
